import { isEmpty } from 'lodash';
import type { IBaseFootprintResponseBody } from '../../../types/response/IBaseFootprintReponseBody';
import { BaseUserProfile } from './BaseUserProfile';
import { SimpleMember } from './SimpleMember';

export class BaseFootprint {
  constructor(
    private readonly _footprintId: string,
    private readonly _footprintableType: string,
    private readonly _footprintableId: string,
    private readonly _members: SimpleMember[],
    private readonly _artistId?: string,
    private readonly _artistName?: string,
    private readonly _reporter?: BaseUserProfile,
    private readonly _description?: string | null,
    private readonly _linktUrl?: string | null,
    private readonly _baseThumbnailUrl?: string | null,
    private readonly _location?: string,
    private readonly _contentType?:
      | 'official_content'
      | 'direct_sighting'
      | 'fan_content'
      | 'live_broadcast',
    private readonly _category?: 'landmark' | 'foodie_spot' | 'filming_location'
  ) {}

  get footprintId(): string {
    return this._footprintId;
  }

  get footprintableType(): string {
    return this._footprintableType;
  }

  get footprintableId(): string {
    return this._footprintableId;
  }

  get artistId(): string | undefined {
    return this._artistId;
  }

  get artistName(): string | undefined {
    return this._artistName;
  }

  get members(): SimpleMember[] {
    return this._members;
  }

  get reporter(): BaseUserProfile | undefined {
    return this._reporter;
  }

  get description(): string | null | undefined {
    return this._description;
  }

  get linkUrl(): string | null | undefined {
    return this._linktUrl;
  }

  get baseThumbnailUrl(): string | null | undefined {
    return this._baseThumbnailUrl;
  }

  get location(): string | undefined {
    return this._location;
  }

  get contentType():
    | 'official_content'
    | 'direct_sighting'
    | 'fan_content'
    | 'live_broadcast'
    | undefined {
    return this._contentType;
  }

  get category(): 'landmark' | 'foodie_spot' | 'filming_location' | undefined {
    return this._category;
  }

  get footprinterName(): string {
    if (isEmpty(this.members)) {
      return this._artistName || '';
    }
    return this.members?.map((member) => member.name).join(', ');
  }

  static fromResponse(response: IBaseFootprintResponseBody): BaseFootprint {
    return new BaseFootprint(
      response.footprintId,
      response.footprintableType,
      response.footprintableId,
      response.members?.map((member) => SimpleMember.fromResponse(member)),
      response.artistId,
      response.artistName,
      response.reporter ? BaseUserProfile.fromResponse(response.reporter) : undefined,
      response.description,
      response.linkUrl,
      response.baseThumbnailUrl,
      response.location,
      response.contentType as
        | 'official_content'
        | 'direct_sighting'
        | 'fan_content'
        | 'live_broadcast'
        | undefined,
      response.category as 'landmark' | 'foodie_spot' | 'filming_location' | undefined
    );
  }
}
